import RewardYouSection from './RewardYouSection';

export default RewardYouSection;